import { LeadCreateRequest } from '@asgard/api-common';
import { getApiPathUrl } from 'utils/api';
import * as fetch from 'utils/fetch';

/**
 * Service to interact with Manfred public Lead
 */
export const ServiceLead = {
  /**
   * Create a new Lead for Manfred
   *
   * @param leadInfo Info to create the new lead
   */
  create: async (dealInfo: LeadCreateRequest): Promise<void> => {
    const url = getApiPathUrl('/v2/public/ui/leads');

    return fetch.post<LeadCreateRequest, void>(`${url}`, dealInfo);
  }
};
